import { MouseButtons } from '@app/AppConstants/AppConstants';
import { BaseRosterSelectionStrategy } from './BaseRosterSelectionStrategy';

export class RosterSelectionStrategyMobileRangeWithoutGap extends BaseRosterSelectionStrategy {
    private _rangeStartCell: Element | null = null;

    public mouseDownHandler(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void {
        if (event.button !== MouseButtons.Left && event.button !== MouseButtons.Right) return;
        const target = event.target as Element;
        if (!target || target.className !== this.cellInnerClass) return;

        if (!target.closest('.date-allowed')) {
            return;
        }

        this._rangeStartCell = target;

        const selectedCells = this.getSelectedCells();
        // the order of calls is important
        if (selectedCells.length > 1) {
            this.updateDomSelection([]);
            this.selectItem(target);
        }
        if (selectedCells.length === 0) {
            this.selectItem(target);
        }
        if (selectedCells.length === 1) {
            const start = selectedCells[0];
            this.updateDomSelection([]);
            this.selectRange(start, target);
        }
    }

    public mouseMoveHandler(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void {
        const rangeStartCell = this._rangeStartCell;
        if (!rangeStartCell) return;
        const target = event.target as HTMLDivElement;
        if (target && target.className !== this.cellInnerClass) return;

        this.selectRange(rangeStartCell, target);
    }

    public documentMouseUpHandler(): void {
        if (!this._rangeStartCell) return;
        this._roster.selectedCells = this.convertToRosterElements(this.getSelectedCells());
        this._rangeStartCell = null;
    }
}
